import { render, staticRenderFns } from "./TimeOffRequestCommentListItem.vue?vue&type=template&id=05edf119&"
import script from "./TimeOffRequestCommentListItem.vue?vue&type=script&lang=ts&"
export * from "./TimeOffRequestCommentListItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports